import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAppFullName, getLogo } from '../../../utils/get-logo';
import { SignUpForm } from './sign-up-form';

const SignUpPage = () => {
  const { t } = useTranslation('auth');
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex items-center gap-2 self-center font-medium">
          <img src={getLogo()} alt={t('logoAlt')} className="h-6 w-6" />
          {getAppFullName()}
        </div>
        <SignUpForm />
      </div>
    </div>
  );
};

export default SignUpPage;
